function StateFonts(state, parameters) {
    let [action, params] = parameters.split("/");

    state = state.state;
    switch (action) {
        case "getAllFonts":
            return getAllFonts();
        case "getFont":
            return getFont(params);
        case "getFontsByPage":
            const [page, pageSize] = params.split(",");
            return getFontsByPage(parseInt(page), parseInt(pageSize));
        default:
            return null;
    }

    function getAllFonts() {
        return state;
    }

    function getFont(id) {      
        return state.filter(element => element.id === id)[0];
    }

    function getFontsByPage(page, pageSize) {
        const start = (page - 1) * pageSize;
        const end = start + pageSize;
        return state.slice(start, end);
    }
}
export default StateFonts;
